export const trainViewEn = {
    kaitongtishi:"Open VIP membership or purchase the course to view the full course",
    kaitongguankan:"Open VIP free viewing",
    buyClass:"Purchase of course",
    mainfei:"free",
    goumai:"buy",
    shikan:"And proved video"
}


// WEBPACK FOOTER //
// ./src/lang/home/trainView/indexEn.js